import React, { useState } from "react";
import PropTypes from "prop-types";
import classes from "./CoachTodoLessonCard.module.css";
import Fonts from "../assets/Fonts";
import Colors from "../assets/Colors";
import { Button } from "../Button/Button";
import {
  LocationIconGray,
  CalendarIconGray,
  ClockIconGray,
  coachDemoImg,
  messageIcon,
  FlagIconBlack,
  CancelCircleIcon,
  CancelIconBlack,
  SendIconBlue,
  ChatBlackIcon,
} from "../../constant/imagePath";
import { Tooltip } from "../Tooltip/index";
import { InputWithButton } from "../InputWithButton/InputWithButton";
import CancelLesson from "../../components/Modals/CoachFlow/Dashboard/CancelLesson/CancelLesson";
import moment from "moment";

export const CoachTodoLessonCard = ({ data, onClick1, onClick2 }) => {
  const [isReply, setIsReply] = useState(false);
  const [reply, setReply] = useState();

  return (
    <div className={classes.cardContainer}>
      <div
        className={`${[classes.card].join(" ")}`}
        style={{ borderColor: Colors.neutralShadesOfWhisper }}
      >
        <style jsx>{`
          .tooltip-inner {
            padding: 8px;
            color: #fff;
            background-color: #222222;
            border-radius: 10px;
          }
        `}</style>

        <div className={`${[classes.profile].join(" ")}`}>
          <img src={data?.userData?.profile} />
        </div>
        <div className={`ms-4 ${[classes.contentBox].join("")}`}>
          <div className={` ${[classes.header].join("")}`}>
            {/* Card Heading */}
            <p
              className={`${[classes.heading].join(" ")}`}
              style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}
            >
              <h5
                style={{
                  ...Fonts.h6,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                {data?.userData?.displayName}
              </h5>{" "}
              has requested a{" "}
              <h5
                className={`${[classes.heading].join(" ")}`}
                style={{
                  ...Fonts.h6,
                  color: Colors.neutralShadesOfNero,
                }}
              >
                {data?.type} {data?.title}
              </h5>
            </p>
            {/* Card Buttons */}
            <div>
              {data?.status === "pending" && (
                <div className="d-flex">
                  <Tooltip
                    position="bottom"
                    text={"decline"}
                    className={classes?.iconBtnTooltipContainer}
                  >
                    <Button
                      customStyle={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b2,
                        padding: "12px",
                      }}
                      icon={CancelIconBlack}
                      onClick={() => onClick1(data?.status)}
                    />
                  </Tooltip>
                  <Button
                    label={"Accept"}
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                    primary={true}
                    onClick={() => onClick2(data?.status)}
                  />
                </div>
              )}

              {data?.status === "accepted" && (
                <div className="d-flex">
                  <Tooltip
                    position="bottom"
                    text={"message"}
                    className={classes?.iconBtnTooltipContainer}
                  >
                    <Button
                      customStyle={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b2,
                        padding: "12px",
                      }}
                      icon={ChatBlackIcon}
                      onClick={() => onClick1(data?.status)}
                    />
                  </Tooltip>

                  <Button
                    label={"Cancel lesson"}
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                    primary={false}
                    onClick={() => onClick2(data?.status)}
                  />
                </div>
              )}
              {data?.status === "last-visited" && (
                <div className="d-flex">
                  <Tooltip
                    position="bottom"
                    text={"report"}
                    className={classes?.iconBtnTooltipContainer}
                  >
                    <Button
                      customStyle={{
                        color: Colors.neutralShadesOfNero,
                        ...Fonts.b2,
                        padding: "12px",
                      }}
                      icon={FlagIconBlack}
                      onClick={() => onClick1(data?.status)}
                    />
                  </Tooltip>

                  <Button
                    label={"Evaluate"}
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px",
                      border: `1px solid ${Colors.neutralShadesOfGainsboro}`,
                    }}
                    primary={false}
                    onClick={() => onClick2(data?.status)}
                  />
                </div>
              )}

              {data?.status === "evaluate" && (
                <Button
                  customStyle={{
                    ...Fonts.b2,
                    padding: "14px 24px 14px 24px",
                    minWidth: "136px",
                    height: "48px",
                  }}
                  onClick={onClick1}
                  primary={true}
                  label={"Evaluate"}
                />
              )}
              {data?.status === "read-evaluation" && (
                <div className="d-flex">
                  <Button
                    customStyle={{
                      ...Fonts.b2,
                      padding: "14px 24px 14px 24px",
                      minWidth: "136px",
                      height: "48px",
                      width: "max-content",
                    }}
                    label={"Read evaluation"}
                  />
                </div>
              )}
            </div>
          </div>
          {/* Center Border */}
          <p className={` ${[classes.halfBorder].join(" ")}`} />
          {/* Main Content */}
          <div className={classes.lastLine}>
            <div>
              <ul>
                <li
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                >
                  <img src={CalendarIconGray} />
                  <span
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    {moment(data?.eventDate).format("MMM DD,YYYY")}
                  </span>
                </li>
                <li
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                >
                  <img src={ClockIconGray} />
                  <span
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    {moment(data?.startTime).format("hh:mm a")}-
                    {moment(data?.endTime).format("hh:mm a")}
                  </span>
                </li>
                <li
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
                >
                  <img src={LocationIconGray} />
                  <span
                    style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                  >
                    income ${data?.price}
                  </span>
                </li>
              </ul>
              <p
                className={classes.location}
                style={{
                  ...Fonts.p2,
                  color: Colors.neutralShadesOfDimGray,
                }}
              >
                <img src={LocationIconGray} />
                <span
                  style={{ ...Fonts.p2, color: Colors.neutralShadesOfNero }}
                >
                  {data?.location}
                </span>
              </p>
            </div>
            {data?.timeLeft && (
              <p
                className={classes.time}
                style={{ ...Fonts.p2, color: Colors.neutralShadesOfDimGray }}
              >
                {data?.timeLeft} left
              </p>
            )}
          </div>
        </div>
      </div>
      {/* Message */}
      {data?.message && (
        <div
          className={classes.msgBox}
          style={{ backgroundColor: Colors.neutralShadesOfWhiteSmoke }}
        >
          <p style={{ ...Fonts.p1, color: Colors.neutralShadesOfNero }}>
            {data?.message}
          </p>
          <p
            style={{
              ...Fonts.b2,
              color: Colors.neutralShadesOfNero,
              lineHeight: "20px",
            }}
            onClick={() => setIsReply(true)}
          >
            Reply
          </p>
        </div>
      )}
      {isReply && (
        <div className={classes.reply}>
          <InputWithButton
            btnIcon={SendIconBlue}
            customStyle={{ width: "100%", height: "48px" }}
            inputStyle={{ height: "48px" }}
            buttonStyle={{ backgroundColor: "#ffffff" }}
            iconStyle={{ width: "24px", height: "20px" }}
            setter={setReply}
            state={reply}
            placeholder="Hi"
          />
        </div>
      )}
      {/*  */}
    </div>
  );
};

CoachTodoLessonCard.propType = {
  data: PropTypes.object,
  onClick1: PropTypes.func,
  onClick2: PropTypes.func,
};
CoachTodoLessonCard.defaultProps = {
  data: {
    userData: {
      displayName: "Tyler",
      profile: coachDemoImg,
    },
    startTime: moment(moment().add(-3, "hours").format())
      .add(0, "days")
      .format(),
    endTime: moment(moment().add(3, "hours").format()).add(0, "days").format(),
    eventDate: moment().add(0, "days").format(),
    type: "1-on-1",
    title: "Tennis Lesson",
    location: "DeWitt Clinton Park, W 54th St, New York, NY",
    price: 64,
    status: "accepted",
    timeLeft: "14 hrs",
  },
};
